import { apiPostAsync } from '../common/service-utils'
import * as constants from '../common/constants'

export async function changeUserPassword(userName, appKey, oldPassword, newPassword, useStoredTemp, data) {
    const postData = { useStoredTemp, userId: userName, newPassword };
    if (appKey) postData.appKey = appKey;
    if (data) postData.data = data;
    if (oldPassword) postData.oldPassword = oldPassword;
    return apiPostAsync(constants.API_CHANGE_USER_PASSWORD, null, postData);
}

export async function sendForgotPassword(userIdEmail, appKey, captchaResponse, redirectUrl, isLauncher, passwordApp, loginApp, data) {
    const postData = {
        email: userIdEmail,
        appKey,
        redirectUrl,
        captchaResponse,
        loginApp,
    };
    if (typeof jspFullLoginUrl != 'undefined' && jspFullLoginUrl) {
        postData.loginUrl = jspFullLoginUrl;
    }
    if (isLauncher) {
        postData.isLauncher = 'Y';
    }
    if (passwordApp) {
        postData.passwordApp = passwordApp;
    }
    if (data) {
        postData.data = data;
    }
    return apiPostAsync(constants.API_FORGOT_PASSWORD, null, postData);
}

export async function getPasswordMessages() {
    return apiPostAsync(constants.API_APP_UI_MSGS, null, { appKey: "ANY", placeHolders: ["PASSWORD_RULES"] });
}

export async function checkPassword(password) {
    return apiPostAsync(constants.API_CHECK_PASSWORD, null, { password }, 3000);
}
